import { Disclosure, Transition } from "@headlessui/react";

import config from "config/config";
import { useTrackFAQ } from "logging";
import { Trans } from "react-i18next";
import { Link } from "react-router-dom";

export default function Accordion({ item }) {
  const trackFAQ = useTrackFAQ();

  return (
    <Disclosure>
      {({ open }) => (
        <div className="ui-card ui-accordion_item">
          <Disclosure.Button
            className="group text-lg text-left p-4 font-semibold flex items-start justify-start hover:text-theme-action-hover"
            onClick={() => trackFAQ(item?.title)}
          >
            <span className="flex-none no-underline mt-[.375rem] mr-4">
              <svg
                className="ui-icon w-4 h-4 text-theme-action group-hover:text-theme-action-hover"
                focusable="false"
                aria-hidden="true"
                role="presentation"
              >
                <use href={`#${open ? "ui-icon-minus" : "ui-icon-plus"}`}></use>
              </svg>
            </span>
            <span className="group-hover:underline">{item.title}</span>
          </Disclosure.Button>
          <Transition
            show={open}
            enter="transition duration-300 ease-out"
            enterFrom="transform scale-y-50 opacity-0"
            enterTo="transform scale-y-100 opacity-100"
            leave="transition duration-300 ease-out"
            leaveFrom="transform scale-y-100 opacity-100"
            leaveTo="transform scale-y-50 opacity-0"
          >
            <Disclosure.Panel className="overflow-hidden transition-all ease-in-out duration-300">
              <div className="p-4 border-t border-theme-rule-medium">
                {item?.FileName ? (
                  <Trans
                    i18nKey={item.desc}
                    components={{
                      a1: (
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            const downloadFile = (fileName) => {
                              if (!fileName) return;
                              const link = document.createElement("a");
                              link.href = `${config.REG_API_BASE_URL}/User/document?FileName=${fileName}`;
                              link.download = "";
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                            };
                            downloadFile(item?.FileName);
                            setTimeout(() => {
                              if (item?.FileName2) {
                                window.open(
                                  `${config.REG_API_BASE_URL}/User/document?FileName=${item.FileName2}`,
                                  "_blank"
                                );
                              }
                            }, 500);
                          }}
                        ></a>
                      ),
                    }}
                  />
                ) : (
                  <Trans
                    defaults={item.desc}
                    values={{ email: config.CUSTOMER_SERVICE_EMAIL }}
                    components={{
                      link1: <Link to="/services-claims"></Link>,
                      link2: <Link to="/payment"></Link>,
                      link3: <Link to="/help#contact-us"></Link>,
                      link4: <Link to="/help"></Link>,
                      link5: <Link to="/services-claims/forms"></Link>,
                      link6: <Link to="/"></Link>,
                      link7: <Link to="/guest/forms"></Link>,
                      linkRegistration: <Link to="/register"></Link>,
                      a1: <a href="tel:844-953-0347"></a>,
                      a2: (
                        <a href={`mailto:${config.CUSTOMER_SERVICE_EMAIL}`}></a>
                      ),
                      ul1: (
                        <ul
                          style={{ listStyleType: "disc", marginLeft: "3rem" }}
                        />
                      ),
                      ul2: (
                        <ul
                          style={{ listStyleType: "disc", marginLeft: "1rem" }}
                        />
                      ),
                      li1: <li />,
                      br1: <br />,
                    }}
                  ></Trans>
                )}
              </div>
            </Disclosure.Panel>
          </Transition>
        </div>
      )}
    </Disclosure>
  );
}
